import React from "react";
import { createRoot } from "react-dom/client";

import { fetchConfig } from "./api/client";
import { App } from "./App";
import "./styles.css";

const root = createRoot(document.getElementById("root")!);

// How to sign in is the server's to say (a test Clerk instance or a live one, or none on a
// laptop), so it is asked before anything renders rather than built into the bundle.
fetchConfig()
  .then((config) => root.render(
    <React.StrictMode>
      <App config={config} />
    </React.StrictMode>,
  ))
  .catch((err: unknown) => root.render(
    <main>
      <p className="empty">The portal did not answer ({err instanceof Error ? err.message : String(err)}). Reload to try again.</p>
    </main>,
  ));
